import { Box } from "@chakra-ui/react";
import { ColorIcon, colors, customEvent, EventProps, HackleEventName, VStack } from "goi_common";
import { useRouter } from "next/router";

function InfoBalloon({
  event = {
    newGtm: {
      path: "parlor_detail",
      trigger_and_target: "check_discount-uv_match_request",
    },
    hackle: { key: HackleEventName["장례식장 할인여부 확인하기 클릭"] },
  },
}: {
  event?: EventProps;
}) {
  const router = useRouter();
  return (
    <Box padding="0 40px 18px" width="100%">
      <VStack gap={12} width="100%" alignItems="center">
        <div className="caption1 gray700">
          11개 상조와 협약된 장례식장이면 빈소 요금을 최대 50% 할인받을 수 있어요.
          <br />
          고이 직영 상담을 통하여 서비스를 이용하신 경우에 한하여 할인 가능합니다.
        </div>
        <Box
          display="flex"
          alignItems="center"
          justifyContent="flex-end"
          className="subtitle4 orange700"
          style={{ cursor: "pointer" }}
          onClick={() => {
            customEvent(event);
            router.push("/match/request");
          }}
        >
          빈소이용료 할인 상담받기
          <ColorIcon name="arrow_right_small" color={colors.orange700} width="12px" height="12px" />
        </Box>
      </VStack>
    </Box>
  );
}

export default InfoBalloon;
